module.exports = __webpack_public_path__ + "img/flying-disc.06527453.svg";